export default {
    TOGGLE_HEADER_SEARCH: 'UI/TOGGLE_HEADER_SEARCH',
    OPEN_GDPR_MODAL: 'UI/OPEN_GDPR_MODAL',
    CLOSE_GDPR_MODAL: 'UI/CLOSE_GDPR_MODAL',
    OPEN_GDPR_SETTINGS: 'UI/OPEN_GDPR_SETTINGS',
    CLOSE_GDPR_SETTINGS: 'UI/CLOSE_GDPR_SETTINGS',
    OPEN_QUICK_VIEW: 'UI/OPEN_QUICK_VIEW',
    CLOSE_QUICK_VIEW: 'UI/CLOSE_QUICK_VIEW',
    OPEN_VIDEO_MODAL: 'UI/OPEN_VIDEO_MODAL',
    CLOSE_VIDEO_MODAL: 'UI/CLOSE_VIDEO_MODAL',
    OPEN_MESSAGING_MODAL: 'UI/OPEN_MESSAGING_MODAL',
    CLOSE_MESSAGING_MODAL: 'UI/CLOSE_MESSAGING_MODAL',
    OPEN_NOTIFICATION_OPTIN_MODAL: 'UI/OPEN_NOTIFICATION_OPTIN_MODAL',
    CLOSE_NOTIFICATION_OPTIN_MODAL: 'UI/CLOSE_NOTIFICATION_OPTIN_MODAL',
    ITEM_LAYOUT: 'UI/ITEM_LAYOUT',
    UPDATE_SYSTEM_MESSAGES: 'UI/UPDATE_SYSTEM_MESSAGES',
    UPDATE_MESSAGING_NOTIFICATIONS: 'UI/UPDATE_MESSAGING_NOTIFICATIONS',
    OPEN_PROFILE_MENU: 'UI/OPEN_PROFILE_MENU',
    CLOSE_PROFILE_MENU: 'UI/CLOSE_PROFILE_MENU',
    OPEN_CATEGORY_DROPDOWN_MENU: 'UI/OPEN_CATEGORY_DROPDOWN_MENU',
    CLOSE_CATEGORY_DROPDOWN_MENU: 'UI/CLOSE_CATEGORY_DROPDOWN_MENU',
    OPEN_SEARCH_FORM: 'UI/OPEN_SEARCH_FORM',
    CLOSE_SEARCH_FORM: 'UI/CLOSE_SEARCH_FORM',
    REQUEST_ITEM_SETTINGS: 'UI/REQUEST_ITEM_SETTINGS',
    OPEN_ITEM_SETTINGS: 'UI/OPEN_ITEM_SETTINGS',
    CLOSE_ITEM_SETTINGS: 'UI/CLOSE_ITEM_SETTINGS',
    SITE_LAYOUT: 'UI/SITE_LAYOUT',
    // General action types without prefix that many reducers can listen to
    LOG_OUT: 'LOG_OUT'
};
